import React, { useState } from "react";

// Shared casino games section (tabs + game cards grid).
// Used on both the Home page and the In-Play page so the layout stays identical.
const GAME_TABS = ["Popular", "Universe Live", "Universe Original", "International", "Slot"];

const GAMES_BY_TAB = {
  Popular: [
    { src: "/pics/Vimaan1.webp", name: "Vimaan" },
    { src: "/pics/20-20-teenpatti.webp", name: "20-20 Teenpatti" },
    { src: "/pics/Lucky-7.webp", name: "Lucky 7" },
    { src: "/pics/1-Day-teenpatti.webp", name: "1 Day Teenpatti" },
    { src: "/pics/Joker-teenpatti.webp", name: "Joker Teenpatti" },
    { src: "/pics/Dragontiger.webp", name: "Dragon Tiger" },
    { src: "/pics/Baccarat.webp", name: "Baccarat" },
    { src: "/pics/Andar-Bahar.webp", name: "Andar Bahar" },
    { src: "/pics/32-cards.webp", name: "32 Cards" },
    { src: "/pics/Poker.webp", name: "Poker" },
    { src: "/pics/DTL.webp", name: "DTL" },
    { src: "/pics/1-Day-Dragon-tiger.webp", name: "1 Day Dragon Tiger" },
    { src: "/pics/muflisteenpatti-01.webp", name: "Muflis Teenpatti" },
    { src: "/pics/CardRace.webp", name: "Card Race" },
    { src: "/pics/AmarAkbarAnthony-01.webp", name: "Amar Akbar Anthony" },
    { src: "/pics/dragon-tiger-01.webp", name: "Dragon Tiger" },
    { src: "/pics/Balloon.webp", name: "Balloon" },
    { src: "/pics/Head-n-Tails.webp", name: "Head n Tails" },
    { src: "/pics/8755.png", name: "Evolution" },
    { src: "/pics/Lucky-0-to-9.webp", name: "Lucky 0 to 9" },
  ],
  "Universe Live": [
    { src: "/pics/20-20-teenpatti.webp", name: "20-20 Teenpatti" },
    { src: "/pics/Lucky-7.webp", name: "Lucky 7" },
    { src: "/pics/1-Day-teenpatti.webp", name: "1 Day Teenpatti" },
    { src: "/pics/Joker-teenpatti.webp", name: "Joker Teenpatti" },
    { src: "/pics/Dragontiger.webp", name: "Dragon Tiger" },
    { src: "/pics/Baccarat.webp", name: "Baccarat" },
    { src: "/pics/Andar-Bahar.webp", name: "Andar Bahar" },
    { src: "/pics/32-cards.webp", name: "32 Cards" },
    { src: "/pics/Poker.webp", name: "Poker" },
  ],
  "Universe Original": [
    { src: "/pics/muflisteenpatti-01.webp", name: "Muflis Teenpatti" },
    { src: "/pics/CardRace.webp", name: "Card Race" },
    { src: "/pics/AmarAkbarAnthony-01.webp", name: "Amar Akbar Anthony" },
    { src: "/pics/dragon-tiger-01.webp", name: "Dragon Tiger" },
    { src: "/pics/Balloon.webp", name: "Balloon" },
    { src: "/pics/Head-n-Tails.webp", name: "Head n Tails" },
    { src: "/pics/Lucky-0-to-9.webp", name: "Lucky 0 to 9" },
  ],
  International: [
    { src: "/pics/wc-top_games.png", name: "Top Games" },
    { src: "/pics/wc-dragontiger.png", name: "Dragon Tiger" },
    { src: "/pics/wc-baccarat.png", name: "Baccarat" },
    { src: "/pics/wc-sicbo.png", name: "Sic Bo" },
    { src: "/pics/wc-fantan.png", name: "Fantan" },
    { src: "/pics/wc-blackjack.png", name: "Blackjack" },
    { src: "/pics/wc-roulette.png", name: "Roulette" },
    { src: "/pics/wc-poker.png", name: "Poker" },
    { src: "/pics/wc-game_shows.png", name: "Game Shows" },
    { src: "/pics/wc-rng.png", name: "RNG" },
    { src: "/pics/wc-casinos_choice.png", name: "Casino Choice" },
    { src: "/pics/wc-all_games.png", name: "All Games" },
    { src: "/pics/ezugi.png", name: "Ezugi" },
    { src: "/pics/ezugi_blackjack.png", name: "Ezugi Blackjack" },
    { src: "/pics/ezugi_baccarat.png", name: "Ezugi Baccarat" },
    { src: "/pics/ezugi_roulette.png", name: "Ezugi Roulette" },
    { src: "/pics/ezugi_lottery.png", name: "Ezugi Lottery" },
    { src: "/pics/ezugi_poker.png", name: "Ezugi Poker" },
    { src: "/pics/sagaming_lobby.png", name: "SA Gaming" },
    { src: "/pics/dreamgaming-lobby.png", name: "Dream Gaming" },
    { src: "/pics/yeebetting-lobby.png", name: "Yee Betting" },
    { src: "/pics/livevegas-2491.png", name: "Live Vegas" },
    { src: "/pics/jili-13445.png", name: "Jili" },
    { src: "/pics/7mojos-14800.png", name: "7 Mojos" },
    { src: "/pics/livegames-21001.png", name: "Live Games" },
    { src: "/pics/creedroomz-29809.png", name: "Creed Roomz" },
    { src: "/pics/tvbet-46012.png", name: "TV Bet" },
  ],
  Slot: [
    { src: "/pics/wc-top_games.png", name: "Top Games" },
    { src: "/pics/wc-dragontiger.png", name: "Dragon Tiger" },
    { src: "/pics/wc-baccarat.png", name: "Baccarat" },
    { src: "/pics/wc-sicbo.png", name: "Sic Bo" },
    { src: "/pics/wc-fantan.png", name: "Fantan" },
    { src: "/pics/wc-blackjack.png", name: "Blackjack" },
    { src: "/pics/wc-roulette.png", name: "Roulette" },
    { src: "/pics/wc-poker.png", name: "Poker" },
    { src: "/pics/wc-game_shows.png", name: "Game Shows" },
    { src: "/pics/wc-rng.png", name: "RNG" },
    { src: "/pics/wc-casinos_choice.png", name: "Casino Choice" },
    { src: "/pics/wc-all_games.png", name: "All Games" },
    { src: "/pics/ezugi.png", name: "Ezugi" },
    { src: "/pics/ezugi_blackjack.png", name: "Ezugi Blackjack" },
    { src: "/pics/ezugi_baccarat.png", name: "Ezugi Baccarat" },
    { src: "/pics/ezugi_roulette.png", name: "Ezugi Roulette" },
    { src: "/pics/ezugi_lottery.png", name: "Ezugi Lottery" },
    { src: "/pics/ezugi_poker.png", name: "Ezugi Poker" },
    { src: "/pics/sagaming_lobby.png", name: "SA Gaming" },
    { src: "/pics/dreamgaming-lobby.png", name: "Dream Gaming" },
    { src: "/pics/yeebetting-lobby.png", name: "Yee Betting" },
    { src: "/pics/livevegas-2491.png", name: "Live Vegas" },
    { src: "/pics/jili-13445.png", name: "Jili" },
    { src: "/pics/7mojos-14800.png", name: "7 Mojos" },
    { src: "/pics/livegames-21001.png", name: "Live Games" },
    { src: "/pics/creedroomz-29809.png", name: "Creed Roomz" },
    { src: "/pics/tvbet-46012.png", name: "TV Bet" },
  ],
};

const CasinoGamesSection = () => {
  const [activeGameTab, setActiveGameTab] = useState("Popular");
  const games = GAMES_BY_TAB[activeGameTab] || [];

  return (
    <>
      {/* Game Category Tabs */}
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          background: "var(--site-header-gradient)",
          padding: "0",
          alignItems: "center",
          height: "40px",
        }}
      >
        {GAME_TABS.map((tab) => {
          const isActive = activeGameTab === tab;
          return (
            <div
              key={tab}
              onClick={() => setActiveGameTab(tab)}
              style={{
                padding: "10px 18px",
                color: isActive ? "#fff" : "#000",
                fontSize: "14px",
                fontWeight: "700",
                fontFamily: "Tahoma, Helvetica, sans-serif",
                cursor: "pointer",
                whiteSpace: "nowrap",
                opacity: isActive ? 1 : 0.7,
              }}
            >
              {tab}
            </div>
          );
        })}
      </div>

      {/* Game Cards Grid — responsive columns, cards keep a fixed aspect ratio
          so mobile (3 cols) and desktop (4+ cols) look identical in proportion. */}
      <div
        className="casino-games-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: "15px 10px",
          padding: "10px 8px",
          backgroundColor: "#e9eaee",
          backgroundImage: 'url("/bg.jpg")',
          backgroundRepeat: "repeat",
          backgroundPosition: "left top",
          backgroundSize: "400px auto",
        }}
      >
        {games.map((game, index) => (
          <div
            key={index}
            className="casino-game-card"
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              cursor: "pointer",
              backgroundColor: "#fff",
              minWidth: 0,
              aspectRatio: "118 / 143",
            }}
          >
            <img
              src={game.src}
              alt={game.name}
              style={{
                width: "100%",
                height: "100%",
                display: "block",
                objectFit: "cover",
                objectPosition: "center top",
              }}
            />
          </div>
        ))}
      </div>

      {/* Desktop: 4 columns to match the reference layout; cards keep aspect
          ratio via aspectRatio above so they never stretch/squash. */}
      <style>{`
        @media (min-width: 1024px) {
          .casino-games-grid {
            grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
            gap: 18px 14px !important;
            padding: 14px 10px !important;
            /* Zoom the bg.jpg wallpaper in on desktop only */
            background-size: 760px auto !important;
          }
          /* Desktop cards are more portrait (taller) to match the reference —
             the default 118/143 looks square in the narrow center column. */
          .casino-games-grid .casino-game-card {
            aspect-ratio: 118 / 158 !important;
          }
        }
      `}</style>
    </>
  );
};

export default CasinoGamesSection;
